import React, { useState } from "react";
import {
  BrowserRouter as Routers,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";
import { connect } from "react-redux";

// Org screens
import SalontypeList from "./SalonType/salontypelist";
import CategoryList from "./Category/categorylist";
import SubCategoryList from "./SubCategory/subcategorylist";
import EditPersonDetails from "./Doctors/editpersondetails";
import EditSalonType from "./SalonType/editsalontype";
import Dashboard from "./Dashboard/dashboard";
import { setLogInDetails, clearAdminRecord } from "../actions/setpersondetailsaction";
import Editcategory from "./Category/editcategory";
import Editsubcategory from "./SubCategory/editsubcategory";
import AddCategory from "./Category/addcategory";
import UserList from "./Users/userlist";
import EditUser from "./Users/edituser";
import VendorList from "./Vendors/vendorlist";
import RequestVendorList from "./Vendors/requestvendorlist";
import EditVendor from "./Vendors/editvendor";
import BannerList from "./Banner/bannerlist";
import EditBanner from "./Banner/editbanner";
import DailyBooking from "./Booking/todaybookinglist";
import CustomerList from "./Customers/customerlist";
import ServiceGroupsList from "./ServiceGroups/servicegroupslist";
import StylistList from "./Stylists/stylistlist";
import EditStylist from "./Stylists/editstylist";
import WorkDetailsList from "./WorkDetails/workdetailslist";
import EditWorkDetails from "./WorkDetails/editworkdetails";
import WalkInForm from "./WalkIn/walkinform";
import StylistCalendar from "./Calendar/stylistcalendar";
import VendorAnalytics from "./Analytics/vendoranalytics";
import VendorRatings from "./Ratings/vendorratings";
import VendorProfile from "./Profile/vendorprofile";

// Role management (super_admin only)
import RoleManagement from "./RoleManagement/RoleManagement";

import firebase from "../firebase";
import { clearAdminSession } from "../utils/adminAuth";
import {
  getUserRole,
  isVendorRole,
  isOrgRole,
  canDelete,
  canAdd,
  canEdit,
  canManageRoles,
  PERM_DELETE,
} from "../utils/rbac";

import "./sliderNavBar.css";

// ── Access-denied guard component ────────────────────────────────────────────
const AccessDenied = () => (
  <div style={{ padding: "40px", textAlign: "center" }}>
    <h2>Access Denied</h2>
    <p>You don't have permission to access this page.</p>
  </div>
);

// ── Route wrapper that checks a permission before rendering ──────────────────
const ProtectedRoute = ({ permission, children }) => {
  const role = getUserRole();
  const roleConfig = {
    super_admin: ["view", "add", "edit", "delete", "manage_roles"],
    admin: ["view", "add", "edit"],
    read_only: ["view"],
    salon_super_admin: ["view", "add", "edit", "delete", "vendor_bookings", "vendor_stylists", "vendor_work_details", "vendor_customers"],
    salon_admin: ["view", "add", "edit", "vendor_bookings", "vendor_stylists", "vendor_work_details", "vendor_customers"],
  };
  const perms = roleConfig[role] || [];
  if (perms.includes(permission)) return children;
  return <AccessDenied />;
};

// ── Vendor-only route (blocks org roles from vendor paths) ───────────────────
const VendorRoute = ({ children }) => {
  if (!isVendorRole()) return <AccessDenied />;
  return children;
};

// ── Org-only route (blocks vendor roles from org paths) ─────────────────────
const OrgRoute = ({ children }) => {
  if (!isOrgRole()) return <AccessDenied />;
  return children;
};

// ── Org navigation links ─────────────────────────────────────────────────────
const OrgNav = ({ selectedCat, setTitleActive }) => (
  <>
    <Link to="/" className="nav_item">
      <li className={selectedCat === "Dashboard" ? "active" : ""} onClick={() => setTitleActive("Dashboard")}>
        <span className="icon"><i className="fa fa-home"></i></span>
        <span className="title">Dashboard</span>
      </li>
    </Link>

    <Link to="/bannerlist" className="nav_item">
      <li className={selectedCat === "Banner" ? "active" : ""} onClick={() => setTitleActive("Banner")}>
        <span className="icon"><i className="fa fa-image"></i></span>
        <span className="title">Banner</span>
      </li>
    </Link>

    <Link to="/salontypelist" className="nav_item">
      <li className={selectedCat === "Salontype" ? "active" : ""} onClick={() => setTitleActive("Salontype")}>
        <span className="icon"><i className="fa fa-scissors"></i></span>
        <span className="title">Salon Type</span>
      </li>
    </Link>

    <Link to="/categorylist" className="nav_item">
      <li className={selectedCat === "Category" ? "active" : ""} onClick={() => setTitleActive("Category")}>
        <span className="icon"><i className="fa fa-list"></i></span>
        <span className="title">Category</span>
      </li>
    </Link>

    <Link to="/subcategorylist" className="nav_item">
      <li className={selectedCat === "SubCategory" ? "active" : ""} onClick={() => setTitleActive("SubCategory")}>
        <span className="icon"><i className="fa fa-bars"></i></span>
        <span className="title">Service Name</span>
      </li>
    </Link>

    <Link to="/servicegroupslist" className="nav_item">
      <li className={selectedCat === "ServiceGroups" ? "active" : ""} onClick={() => setTitleActive("ServiceGroups")}>
        <span className="icon"><i className="fa fa-tags"></i></span>
        <span className="title">Service Groups</span>
      </li>
    </Link>

    <Link to="/userlist" className="nav_item">
      <li className={selectedCat === "User" ? "active" : ""} onClick={() => setTitleActive("User")}>
        <span className="icon"><i className="fa fa-users"></i></span>
        <span className="title">User</span>
      </li>
    </Link>

    <Link to="/vendorlist" className="nav_item">
      <li className={selectedCat === "Vendor" ? "active" : ""} onClick={() => setTitleActive("Vendor")}>
        <span className="icon"><i className="fa fa-briefcase"></i></span>
        <span className="title">Vendor</span>
      </li>
    </Link>

    <Link to="/todaybookinglist" className="nav_item">
      <li className={selectedCat === "Booking" ? "active" : ""} onClick={() => setTitleActive("Booking")}>
        <span className="icon"><i className="fa fa-calendar"></i></span>
        <span className="title">Booking</span>
      </li>
    </Link>

    <Link to="/customerlist" className="nav_item">
      <li className={selectedCat === "Customers" ? "active" : ""} onClick={() => setTitleActive("Customers")}>
        <span className="icon"><i className="fa fa-address-book"></i></span>
        <span className="title">Customers</span>
      </li>
    </Link>

    <Link to="/stylistlist" className="nav_item">
      <li className={selectedCat === "Stylists" ? "active" : ""} onClick={() => setTitleActive("Stylists")}>
        <span className="icon"><i className="fa fa-cut"></i></span>
        <span className="title">Stylists</span>
      </li>
    </Link>

    <Link to="/workdetailslist" className="nav_item">
      <li className={selectedCat === "WorkDetails" ? "active" : ""} onClick={() => setTitleActive("WorkDetails")}>
        <span className="icon"><i className="fa fa-clock-o"></i></span>
        <span className="title">Work Details</span>
      </li>
    </Link>

    {/* Role management – super_admin only */}
    {canManageRoles() && (
      <Link to="/rolemanagement" className="nav_item">
        <li className={selectedCat === "RoleManagement" ? "active" : ""} onClick={() => setTitleActive("RoleManagement")}>
          <span className="icon"><i className="fa fa-shield"></i></span>
          <span className="title">Role Management</span>
        </li>
      </Link>
    )}
  </>
);

// ── Vendor navigation links ──────────────────────────────────────────────────
const VendorNav = ({ selectedCat, setTitleActive, adminRecord }) => (
  <>
    {/* Vendor badge */}
    {adminRecord?.vendorName && (
      <div className="vendor_badge">
        <i className="fa fa-store"></i>
        <span>{adminRecord.vendorName}</span>
      </div>
    )}

    <Link to="/stylistcalendar" className="nav_item">
      <li className={selectedCat === "StylistCalendar" ? "active" : ""} onClick={() => setTitleActive("StylistCalendar")}>
        <span className="icon"><i className="fa fa-calendar-check-o"></i></span>
        <span className="title">Calendar</span>
      </li>
    </Link>

    <Link to="/analytics" className="nav_item">
      <li className={selectedCat === "Analytics" ? "active" : ""} onClick={() => setTitleActive("Analytics")}>
        <span className="icon"><i className="fa fa-bar-chart"></i></span>
        <span className="title">Analytics</span>
      </li>
    </Link>

    <Link to="/todaybookinglist" className="nav_item">
      <li className={selectedCat === "Booking" ? "active" : ""} onClick={() => setTitleActive("Booking")}>
        <span className="icon"><i className="fa fa-calendar"></i></span>
        <span className="title">Bookings</span>
      </li>
    </Link>

    <Link to="/stylistlist" className="nav_item">
      <li className={selectedCat === "Stylists" ? "active" : ""} onClick={() => setTitleActive("Stylists")}>
        <span className="icon"><i className="fa fa-cut"></i></span>
        <span className="title">Stylists</span>
      </li>
    </Link>

    <Link to="/workdetailslist" className="nav_item">
      <li className={selectedCat === "WorkDetails" ? "active" : ""} onClick={() => setTitleActive("WorkDetails")}>
        <span className="icon"><i className="fa fa-clock-o"></i></span>
        <span className="title">Work Details</span>
      </li>
    </Link>

    <Link to="/customerlist" className="nav_item">
      <li className={selectedCat === "Customers" ? "active" : ""} onClick={() => setTitleActive("Customers")}>
        <span className="icon"><i className="fa fa-address-book"></i></span>
        <span className="title">Customers</span>
      </li>
    </Link>

    <Link to="/subcategorylist" className="nav_item">
      <li className={selectedCat === "SubCategory" ? "active" : ""} onClick={() => setTitleActive("SubCategory")}>
        <span className="icon"><i className="fa fa-list-alt"></i></span>
        <span className="title">Service Name</span>
      </li>
    </Link>

    <Link to="/walkin" className="nav_item">
      <li className={selectedCat === "WalkIn" ? "active" : ""} onClick={() => setTitleActive("WalkIn")}>
        <span className="icon"><i className="fa fa-plus-square"></i></span>
        <span className="title">Add Walk-In</span>
      </li>
    </Link>

    <Link to="/ratings" className="nav_item">
      <li className={selectedCat === "Ratings" ? "active" : ""} onClick={() => setTitleActive("Ratings")}>
        <span className="icon"><i className="fa fa-star"></i></span>
        <span className="title">Ratings</span>
      </li>
    </Link>

    <Link to="/profile" className="nav_item">
      <li className={selectedCat === "Profile" ? "active" : ""} onClick={() => setTitleActive("Profile")}>
        <span className="icon"><i className="fa fa-user-circle"></i></span>
        <span className="title">Profile</span>
      </li>
    </Link>

  </>
);

// ── Main SideNavBar ──────────────────────────────────────────────────────────
const SideNavBar = (props) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedCat, setSelectedCat] = useState("Dashboard");

  const role = getUserRole();
  const vendorRole = isVendorRole();
  const adminRecord = props.adminRecord;

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  const logout = () => {
    clearAdminSession();
    props.clearAdminRecord();
    firebase.auth().signOut();
    props.setOnLogInDetails({ isLoggedIn: false });
  };

  const setTitleActive = (cat) => setSelectedCat(cat);

  // Role label shown in top-bar
  const roleLabel = {
    super_admin: "Super Admin",
    admin: "Admin",
    read_only: "Read Only",
    salon_super_admin: "Salon Super Admin",
    salon_admin: "Salon Admin",
  }[role] || role;

  return (
    <div className="dashboard_wrapper">
      <Routers>
        {/* Sidebar */}
        <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>
          <div className="sidebar_logo">
            <i className="fa fa-cube"></i>
            <span>Zenith Cult</span>
          </div>

          <nav className="sidebar_nav">
            {vendorRole
              ? <VendorNav selectedCat={selectedCat} setTitleActive={setTitleActive} adminRecord={adminRecord} />
              : <OrgNav selectedCat={selectedCat} setTitleActive={setTitleActive} />
            }
          </nav>
        </aside>

        {/* Top Navigation Bar */}
        <div className="main_content">
          <header className="top_navbar">
            <div className="navbar_left">
              <button className="hamburger" onClick={toggleSidebar}>
                <i className="fa fa-bars"></i>
              </button>
              <h1 className="page_title">
                Zenith Cult {vendorRole ? `— ${adminRecord?.vendorName || "Vendor"}` : "— Admin"}
              </h1>
            </div>

            <div className="navbar_right">
              <span className="role_badge">{roleLabel}</span>
              <button className="icon_btn">
                <i className="fa fa-search"></i>
              </button>
              <button className="icon_btn">
                <i className="fa fa-bell"></i>
              </button>
              <button className="icon_btn" onClick={logout} title="Logout">
                <i className="fa fa-sign-out"></i>
              </button>
            </div>
          </header>

          {/* Main Content Area */}
          <main className="main_container">
            <Switch>
              {/* ── Default home ───────────────────────────────── */}
              <Route exact path="/">
                {vendorRole ? <Redirect to="/stylistcalendar" /> : <Dashboard />}
              </Route>

              {/* ── Analytics (vendor) / Dashboard (org) ─────────── */}
              <Route path="/analytics">
                {vendorRole
                  ? <VendorRoute><VendorAnalytics /></VendorRoute>
                  : <OrgRoute><Dashboard /></OrgRoute>
                }
              </Route>

              {/* ── Vendor-specific routes ────────────────────── */}
              <Route path="/todaybookinglist">
                {vendorRole
                  ? <VendorRoute><DailyBooking /></VendorRoute>
                  : <OrgRoute><DailyBooking /></OrgRoute>
                }
              </Route>
              <Route path="/stylistlist">
                {vendorRole
                  ? <VendorRoute><StylistList /></VendorRoute>
                  : <OrgRoute><StylistList /></OrgRoute>
                }
              </Route>
              <Route path="/editstylist">
                {vendorRole
                  ? <VendorRoute><EditStylist /></VendorRoute>
                  : <OrgRoute><EditStylist /></OrgRoute>
                }
              </Route>
              <Route path="/workdetailslist">
                {vendorRole
                  ? <VendorRoute><WorkDetailsList /></VendorRoute>
                  : <OrgRoute><WorkDetailsList /></OrgRoute>
                }
              </Route>
              <Route path="/editworkdetails">
                {vendorRole
                  ? <VendorRoute><EditWorkDetails /></VendorRoute>
                  : <OrgRoute><EditWorkDetails /></OrgRoute>
                }
              </Route>
              <Route path="/customerlist">
                {vendorRole
                  ? <VendorRoute><CustomerList /></VendorRoute>
                  : <OrgRoute><CustomerList /></OrgRoute>
                }
              </Route>
              <Route path="/walkin">
                <VendorRoute><WalkInForm /></VendorRoute>
              </Route>
              <Route path="/stylistcalendar">
                <VendorRoute><StylistCalendar /></VendorRoute>
              </Route>
              <Route path="/ratings">
                <VendorRoute><VendorRatings /></VendorRoute>
              </Route>
              <Route path="/profile">
                <VendorRoute><VendorProfile /></VendorRoute>
              </Route>

              {/* ── Org-only routes (vendor roles see AccessDenied) ── */}
              <Route path="/salontypelist">
                <OrgRoute><SalontypeList /></OrgRoute>
              </Route>
              <Route path="/categorylist">
                <OrgRoute><CategoryList /></OrgRoute>
              </Route>
              <Route path="/addcategory">
                <OrgRoute><AddCategory /></OrgRoute>
              </Route>
              <Route path="/subcategorylist">
                <ProtectedRoute permission="view"><SubCategoryList /></ProtectedRoute>
              </Route>
              <Route path="/userlist">
                <OrgRoute><UserList /></OrgRoute>
              </Route>
              <Route path="/edituser">
                <OrgRoute><EditUser /></OrgRoute>
              </Route>
              <Route path="/vendorlist">
                <OrgRoute><VendorList /></OrgRoute>
              </Route>
              <Route path="/requestvendorlist">
                <OrgRoute><RequestVendorList /></OrgRoute>
              </Route>
              <Route path="/editvendor">
                <OrgRoute><EditVendor /></OrgRoute>
              </Route>
              <Route path="/bannerlist">
                <OrgRoute><BannerList /></OrgRoute>
              </Route>
              <Route path="/editbanner">
                <OrgRoute><EditBanner /></OrgRoute>
              </Route>
              <Route path="/editsalontype">
                <OrgRoute><EditSalonType /></OrgRoute>
              </Route>
              <Route path="/editcategory">
                <OrgRoute><Editcategory /></OrgRoute>
              </Route>
              <Route path="/editsubcategory">
                <ProtectedRoute permission="edit"><Editsubcategory /></ProtectedRoute>
              </Route>
              <Route path="/servicegroupslist">
                <OrgRoute><ServiceGroupsList /></OrgRoute>
              </Route>
              <Route path="/editpersondetails">
                <OrgRoute><EditPersonDetails /></OrgRoute>
              </Route>

              {/* ── Role Management (super_admin only) ─────────── */}
              <Route path="/rolemanagement">
                <ProtectedRoute permission="manage_roles">
                  <RoleManagement />
                </ProtectedRoute>
              </Route>

              <Redirect to="/" />
            </Switch>
          </main>
        </div>
      </Routers>
    </div>
  );
};

const mapStateToProps = (state) => ({
  adminRecord: state.admin?.adminRecord || null,
});

const mapDispatchToProps = (dispatch) => ({
  setOnLogInDetails: (p) => dispatch(setLogInDetails(p)),
  clearAdminRecord: () => dispatch(clearAdminRecord()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SideNavBar);
